import { Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { OrderStatus } from '@app/api/models/order';
import { booleanBodyRender, TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (status: OrderStatus) => void;
}): TableColumn<OrderStatus>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: { type: 'text', name: 'id' },
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: { type: 'text', name: 'name' },
        sort: true,
      },
    },
    {
      name: 'is_active',
      label: 'Активен',
      options: {
        filter: { type: 'boolean', name: 'is_active' },
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, { rowData }) => (
          <Flex gap={2}>
            <IconButton
              name="edit"
              aria-label="edit"
              size="sm"
              onClick={() => onEdit(rowData as OrderStatus)}
            >
              <MdEdit />
            </IconButton>
          </Flex>
        ),
      },
    },
  ];
};
